import { SOCIOPATH_TEST_ASSESSMENT_ID } from "./general-config";

// Shared DEVELOPMENT/QA/STAGING-only assessment preview mechanism, used
// across the Plan → Checkout funnel (Plan applies it to assessment-plan
// type selection; Checkout applies it to Review Order presentation only).
// Not Plan-specific — any page in this funnel can call getAssessmentDebugId
// instead of re-implementing this gate.

// Environments where the assessment debug override is allowed at all.
// Explicit allowlist, not `!== "PRODUCTION"` — an unknown/missing/
// misspelled REACT_APP_ENVIRONMENT value must fail closed, not
// accidentally pass.
const ASSESSMENT_DEBUG_ALLOWED_ENVIRONMENTS = ["DEVELOPMENT", "QA", "STAGING"];

// assessmentDebug=<key> → real assessment ID. A closed lookup table, not a
// pass-through — an unrecognized/misspelled key must fail closed, never
// silently accept an arbitrary string as an assessment ID.
const ASSESSMENT_DEBUG_ASSESSMENT_IDS = {
  sociopath: SOCIOPATH_TEST_ASSESSMENT_ID,
};

// Gate requires ALL THREE, mirroring
// sociopath-test-report/dev-tools/report-debug-panel.js's pattern: an
// allowlisted lower-environment build, an explicit opt-in flag, AND the
// query flag itself.
//
// Production remains fail-closed in two ways:
// 1. PRODUCTION is not in ASSESSMENT_DEBUG_ALLOWED_ENVIRONMENTS.
// 2. REACT_APP_ENABLE_PLAN_DEV_TOOLS is committed as "true" only in
//    .env/.env.QA/.env.STAGE and explicitly "false" in .env.PRODUCTION —
//    same operational model as REACT_APP_ENABLE_REPORT_DEV_TOOLS.
//
// Every caller (Plan, Checkout, ...) must call this directly rather than
// trust a value forwarded from another page — e.g. Checkout re-resolves
// its own ?assessmentDebug= independently instead of trusting whatever
// Plan forwarded across navigation.
export const getAssessmentDebugId = (queryParams) => {
  if (
    !ASSESSMENT_DEBUG_ALLOWED_ENVIRONMENTS.includes(
      process.env.REACT_APP_ENVIRONMENT,
    )
  ) {
    return null;
  }

  if (process.env.REACT_APP_ENABLE_PLAN_DEV_TOOLS !== "true") {
    return null;
  }

  const key = queryParams.get("assessmentDebug");
  return ASSESSMENT_DEBUG_ASSESSMENT_IDS[key] ?? null;
};
